import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue'

const defaultEl = {
  id: null,
  name: '',
  code: '',
  title: '',
  description: '',
  displayMaterialLookup: false
};

export default {
  data () {
    return {
      editEl: defaultEl,
      loading: false
    }
  },
  components: {
    DatePeriodPicker
  },
  validations: {
    editEl: {
      name: { },
      title: { },
      description: { },
      displayMaterialLookup: { },
      order: { }
    }
  },
  computed: {
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.config.reports.reports.edit');
      }
      return this.$t('menu.config.reports.reports.new');
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
        this.editEl.displayMaterialLookup = (parseInt(this.editEl.displayMaterialLookup) === 1);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const reqData = {
          id: this.editEl.id,
          code: this.editEl.code
        };
        const self = this;
        Object.keys(this.$v.editEl.$params).forEach(paramName => {
          reqData[paramName] = self.editEl[paramName];
        });
        this.ApiRequest.request('report/config', this.ApiRequest.REQUEST_POST, { report: reqData }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
